import React, { useState, useEffect } from "react";
import ImageViewer from "../../Shared/Components/ImageViewer/ImageViewer";
import Header from "../../Shared/Components/Header/Header";
import MenuDropdown from "../../Shared/Components/MenuDropdown/MenuDropdown";
import Modal from "../../Shared/Components/Modal/CustomModal";
import TimelineProgress from "../../Shared/Components/TimelineProgress/TimelineProgress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CONSTANTS } from '../../Environments/constants';
import { faDownload, faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Divider, Input, Button, Affix, Tooltip, Select, Image } from "antd";
import { ServiceUtils } from "../../../src/Shared/Utils/ServiceUtils";
import { sessionService } from "../../Shared/Utils/SessionService";
import { alertService } from "../../../src/Shared/Utils/ToasterUtils";
import Spinner from "../../Shared/Components/Spinner/Spinner";
import classNames from "classnames";
import "./ComplaintDetails.scss";
import { textEllipsis } from "../../Shared/Utils/CommonUtils";
const { TextArea } = Input;


export default function ComplaintDetails(props) {
  const { currentComplaintId,
    onClickStateDashboard,
    onClickAdminDashboard,
    onClickDashboard,
    onClickBack,
    selectedUlb,
    selectedRo,
    selectedState
  } = props
  const [comment, setComment] = useState("");
  const [complaintData, setComplaintData] = useState();
  const [actionItems, setActionItems] = useState();
  const [isValidationError, setIsValidationError] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState()
  const [dropDownValues, setDropDownValues] = useState();
  const [pdfTitle, setPdfTitle] = useState();
  const [pdfData, setPdfData] = useState();
  const [actionType, setActionType] = useState();
  const userDetails = sessionService.getSession("cpcb-user");
  useEffect(() => {
    fetchComplaintDetails();
    fetchActionItemsList();
    handlePdfDownload();
  }, []);

  let generateFile = (content, fileName) => {
    const blob = new Blob([content], { type: "application/pdf" });
    console.log(blob);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "complaint_report";
    link.click();
  };

  const onCancelModal = () => {
    setIsShowModal(false);
    setDropDownValues([]);
  }

  const formatActionItems = () => {
    const steps = [];
    if (actionItems?.length > 0)
      actionItems.forEach((item) => {
        let temp = item;
        if (item.title === "assigned") {
          temp.title = "Complaint assigned";
          temp.description = temp.description;
          temp.message = temp.message;
          steps.push(temp);
        } else if (item.title === "resolved") {
          temp.title = "Complaint resolved";
          temp.description = temp.description;
          temp.message = temp.message;
          steps.push(temp);
        }
        else steps.push(temp);
      });
    return steps;
  };

  const onClickDetailsDashboard = () => {
    if (userDetails?.role && userDetails?.role[0] === "ulb") {
      onClickBack();
    }
    else if (userDetails?.role && userDetails?.role[0] === "rdo")
      onClickDashboard();
    else if (userDetails?.role && userDetails?.role[0] === "state")
      onClickStateDashboard()
    else if (userDetails?.role && userDetails?.role[0] === "all")
      onClickAdminDashboard()

  }

  const onSubmitComment = () => {
    let payload;
    if (!comment) {
      setIsValidationError(true);
    } else {
      var currentdate = new Date();
      const timeStamp = currentdate.toString();
      if (currentComplaintId)
        payload = {
          user_id: userDetails.user_id,
          user_type: userDetails.role[0],
          complaint_id: currentComplaintId,
          comments: comment,
          timeStamp,
        };

      const encodedPayload = btoa(JSON.stringify(payload));
      ServiceUtils.postRequest("add-comments", encodedPayload).then(
        (_response) => {
          let decodedData;
          if (_response?.data) {
            decodedData = JSON.parse(atob(_response.data));
          }
          setComment("");
          fetchActionItemsList();
          if (_response.status === 200) {
            if (decodedData?.status === "success") {
              alertService.success(
                decodedData?.message || `Comments added successfully`
              );
            } else {
              alertService.error(
                decodedData?.message || `Error while adding comments`
              );
            }
          } else {
            alertService.error(
              decodedData?.data?.message ||
              decodedData?.message ||
              "Internal Server Error"
            );
          }
        }
      );
    }
  };

  const fetchActionItemsList = () => {
    let payload;
    if (currentComplaintId)
      payload = {
        complaint_id: currentComplaintId,
      };

    const encodedPayload = btoa(JSON.stringify(payload));
    ServiceUtils.postRequest("list-action-items", encodedPayload).then(
      (_response) => {
        let decodedData;
        if (_response?.data) {
          decodedData = JSON.parse(atob(_response.data));
        }
        if (_response.status === 200) {
          if (decodedData?.status === "success") {
            setActionItems(decodedData?.comments);
          } else {
            alertService.error(
              decodedData?.message || `Error while listing actions`
            );
          }
        } else {
          alertService.error(
            decodedData?.data?.message ||
            decodedData?.message ||
            "Internal Server Error"
          );
        }
      }
    );
  };
  const fetchComplaintDetails = () => {
    let payload;
    if (currentComplaintId)
      payload = {
        complaint_id: currentComplaintId,
      };

    setIsPageLoading(true);
    const encodedPayload = btoa(JSON.stringify(payload));
    ServiceUtils.postRequest("complaint-details", encodedPayload).then(
      (_response) => {
        let decodedData;
        if (_response?.data) {
          decodedData = JSON.parse(atob(_response.data));
        }
        if (_response.status === 200) {
          if (decodedData?.status === "success") {
            setIsPageLoading(false);
            setComplaintData(decodedData?.data);
          } else {
            alertService.error(
              decodedData?.message || `Error while fetching complaint details`
            );
          }
        } else {
          alertService.error(
            decodedData?.data?.message ||
            decodedData?.message ||
            "Internal Server Error"
          );
        }
      }
    );
  };
  const updateStatus = (key, comments) => {
    const payload = {
      complaint_id: currentComplaintId,
      action_type: key,
      user_id: userDetails?.user_id,
      user_type: userDetails?.role,
      comments: comments,
    };
    const encodedPayload = btoa(JSON.stringify(payload));
    ServiceUtils.postRequest("ulb-action-status", encodedPayload).then((_response) => {
      if (_response.status === 200) {
        let response = JSON.parse(atob(_response?.data))
        if (response?.status === "success") {
          alertService.success("Action updated successfully");
          setRefresh(!refresh);
        } else {
          alertService.error(
            _response?.data?.message || "Error in Taking Action"
          );
        }
      } else {
        alertService.error(_response?.data?.message || "Unable To Take Action");
      }
    });
  }

  const handleChange = (e) => {
    if (e?.target?.value) {
      setIsValidationError(false);
    }
    setComment(e?.target?.value);
  };

  const handleDropDownClick = ({ key }) => {
    setActionType(key)
    if (key.includes("return_to_")) {
      const titleValue = key.replace("return_to_", "Send to ")
      setModalTitle(titleValue);
      setIsShowModal(true);
    }
    else if (key === "assign" || key === "transfer") {
      setModalTitle(key);
      getDropdownValues(key);
    }
    else if (key === "resolved") {
      setModalTitle("Resolve complaint");
      setIsShowModal(true);
    }
    else {
      updateStatus(key);
    }

  }

  const getDropdownValues = (type) => {
    const payload = {
      user_id: userDetails?.user_id,
      type: type,
    };
    const encodedPayload = btoa(JSON.stringify(payload));
    ServiceUtils.postRequest("dropdown-list", encodedPayload).then(
      (_response) => {
        let decodedData;
        if (_response?.data) {
          decodedData = JSON.parse(atob(_response.data));
        }
        if (_response.status === 200) {
          if (decodedData?.status === "failed") {
            alertService.error(
              decodedData?.message || `Error while listing values`
            );
          } else {
            setDropDownValues(decodedData);
            setIsShowModal(true);
          }
        } else {
          alertService.error(
            decodedData?.data?.message ||
            decodedData?.message ||
            "Internal Server Error"
          );
        }
      }
    );
  }
  const handlePdfDownload = (e) => {
    console.log(e);
    console.log('pdf Clicked');

    let payload = {
      complaint_id: currentComplaintId,
      user_id: userDetails?.user_id,
      user_type: userDetails?.role[0],
      download: true
    }
    console.log(payload);
    const encodedPayload = btoa(JSON.stringify(payload));
    ServiceUtils.postRequest("download-pdf", encodedPayload).then((_response) => {
      if (_response.status === 200) {
        setPdfData(_response.data);
      } else {
        alertService.error(_response?.data?.message || "Unable To Download PDF");
      }
    });


  }

  return (
    <div>
      <Header />
      <Affix offsetTop={46}>
        <>
          <div className="breadCrumb">
            <div className="path-display-container">
              <div className="backIcon"
                onClick={() => onClickBack()}
              >
                <FontAwesomeIcon
                  icon={faCircleArrowLeft}
                />
              </div>
              <div
                className="breadCrumbLink"
                onClick={onClickDetailsDashboard}
              >
                Dashboard
              </div>
              <div className="divider">/</div>
              {selectedState && (
                <>
                  <div className="breadCrumbLink" onClick={onClickStateDashboard}>
                    {selectedState.title}
                  </div>
                  <div className="divider">/</div>
                </>
              )}
              {selectedRo && (
                <>
                  <div className="breadCrumbLink" onClick={onClickDashboard}>
                    {props.selectedRo.title}
                  </div>
                  <div className="divider">/</div>
                </>
              )}
              {selectedUlb && (
                <>
                  <div className="breadCrumbLink" onClick={onClickBack}>
                    {selectedUlb.title}
                  </div>
                  <div className="divider">/</div>
                </>
              )}
              <div className="breadCrumbContent">
                {currentComplaintId}
              </div>
            </div>
            {complaintData?.currentStatus !== "resolved" && userDetails?.role[0]?.toLowerCase() !== "all" && userDetails?.role[0]?.toLowerCase() !== "state_admin" &&
            <div className="dropdown-container">
              <MenuDropdown className="dropdown-container" label="Actions" role={userDetails?.role[0]} handleDropDownClick={handleDropDownClick} currentStatus={complaintData?.currentStatus} />
            </div>
          }
          </div>
        </>
      </Affix>
      {isPageLoading ?
        <Spinner />
        :
        <div className="container">
          <div className="contentContainer">
            <Row gutter={2}>
              <Col
                xl={{ span: 6 }}
                lg={{ span: 7 }}
                md={{ span: 8 }}
                sm={{ span: 9 }}
                xs={{ span: 10 }}
              >
                <div className="complaint-id-container">
                  <div className="complaint-id">{currentComplaintId}</div>
                </div>
              </Col>
              <Col
                xl={{ span: 15 }}
                lg={{ span: 13 }}
                md={{ span: 11 }}
                sm={{ span: 9 }}
                xs={{ span: 6 }}
              ></Col>
              <Col
                xl={{ span: 3 }}
                lg={{ span: 4 }}
                md={{ span: 5 }}
                sm={{ span: 6 }}
                xs={{ span: 8 }}
                className="download-pdf-column"
              >
                <Tooltip title={CONSTANTS.PDF_DOWNLOAD}>
                  <FontAwesomeIcon
                    icon={faDownload}
                    className="download-pdf-button"
                    onClick={() => generateFile(pdfData, pdfTitle)}
                  />
                </Tooltip>
                {/* <Button className="download-pdf-button" onClick={() => generateFile(pdfData, pdfTitle)} > */}

                {/* {CONSTANTS.PDF_DOWNLOAD}
                </Button> */}
                {/* </a> */}
              </Col>
            </Row>
            <Row gutter={11}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="first-column"
              >
                <div className="column-one-element title">
                  {CONSTANTS.GENERAL_INFO}
                </div>
                <div className="item-container">
                  <div className="column-one-element sub-header">{CONSTANTS.NAME}</div>
                  <div className="column-one-element details">
                    {complaintData?.name}
                  </div>
                </div>
                <div className="item-container">
                  <div className="column-one-element sub-header">{CONSTANTS.LOCATION}</div>
                  <div className="column-one-element details">
                    {complaintData?.location}{" "}
                    <div>

                      <a
                        href={complaintData?.map}
                        className="view-in-map"
                        target="_blank"
                      >
                        <div>
                          {CONSTANTS.MAP_VIEW}
                        </div>
                        <div>
                          {/* <img src="http://192.168.0.234:9000/complaints-management/4fbae99f-17fe-4249-93b0-a0924dd7cf8f_waste.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=minioadmin%2F20220719%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20220719T050539Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=1ac89bf89698fdc55e2c4b4acbd41bab65252922a9c7b827ac1d8dda5d4b5569"></img> */}
                          {complaintData?.src &&
                            <Image
                              width={200}
                              // src={complaintData?.src}
                              // src="https://maps.googleapis.com/maps/api/staticmap?center=0.0000,0.0000&zoom=13&size=200x200&maptype=roadmap&markers=0.0000,0.0000&sensor=false"
                              src="https://maps.googleapis.com/maps/api/staticmap?center=13.033073702379376,77.60862350463867&zoom=16&scale=false&size=300x150&maptype=roadmap&key=AIzaSyAvAdsfn_bAUnX0X2mvwhBQxt6JdOnfb04&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff7b7b%7Clabel:%7C13.033073702379376,77.60862350463867&markers=size:mid%7Ccolor:0xd95a5a%7Clabel:%7C13.033073702379376,77.60862350463867"
                            />
                          }
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="item-container">
                  <div className="column-one-element sub-header">
                    {CONSTANTS.PHONE}
                  </div>
                  <div className="column-one-element details">
                    {complaintData?.mobile}
                  </div>
                </div>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                md={{ span: 12 }}
                lg={{ span: 9 }}
                className="second-column"
              >
                <div className="column-one-element title" id="category">
                  <div>{CONSTANTS.CATEGORY}</div>
                </div>
                <div className="item-container tableContainer">
                  {complaintData?.category?.map((item) => {
                    return (
                      <tr>
                        <td
                          className="column-one-element details"
                        >
                          <span className="sub-header">
                            <Tooltip title={item}>
                              {textEllipsis(item, 30)}
                            </Tooltip>
                            {"  "}
                          </span>
                        </td>
                        <td> - </td>
                        <td className="td">
                          <Tooltip
                            title={complaintData?.all_category[item]?.join(", ")}
                          >
                            {`${textEllipsis(
                              complaintData?.all_category[item]?.join(", "),
                              100
                            )}`}
                          </Tooltip>
                        </td>
                      </tr>
                    );
                  })}
                </div>
                <div>
                  <div className="column-one-element title">
                    <div>{CONSTANTS.SOURCE}</div>
                  </div>
                  <div className="column-one-element details" id="source-item">
                    <Tooltip title={complaintData?.main_category}>
                      {textEllipsis(complaintData?.main_category, 60)}
                    </Tooltip>
                  </div>
                </div>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 9 }}
              >
                <div className="fst-row-column-three">
                  <div className="title">{CONSTANTS.COMPLAINT_DESCRIPTION}</div>
                  <div className="details" id="complaint-description">
                    {complaintData?.description}
                  </div>
                  <div className="title">{CONSTANTS.FILES_ATTACHED}</div>
                  <div>
                    <p class="text-near-image">{CONSTANTS.IMAGES}</p>
                  </div>
                  <div className="image-container">
                    <ImageViewer images={complaintData?.images} />
                  </div>
                  {complaintData?.docs?.length > 0 &&
                    <>
                      <div className="title">Actions Taken</div>
                      <div>
                        <p class="text-near-image documents-text">Documents</p>
                      </div>
                      {complaintData?.docs?.map((doc, idx) => {
                        return (
                          <div className="pdf-file">
                            <span style={{ color: "black" }}>{`${idx + 1}. `}</span>
                            <span><a href={doc.value} target="_blank">{doc.key}</a></span>
                          </div>
                        )
                      })}
                    </>
                  }
                </div>
              </Col>
            </Row>
            <Divider />
            <Row gutter={11}>
              <Col sm={{ span: 24 }} md={{ span: 12 }}>
                {/* <div className="borderStyle"> */}
                <div className="row-2-heading title">{CONSTANTS.ACTION_DETAILS}</div>
                <div className="progressor-bar">
                  <TimelineProgress stepList={formatActionItems()} />
                  {/* <Progressbar stepList={formatActionItems()} /> */}
                </div>
                {/* </div> */}
              </Col>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
                <div className="comment-box-container">
                  <div className="column-two-element commentContainer">{CONSTANTS.COMMENTS}</div>
                  <div className="comment-box">
                    <TextArea
                      placeholder="Enter comments"
                      className={classNames(
                        {
                          'validationError': isValidationError,
                        }
                      )}
                      style={{
                        height: 120,
                      }}
                      onChange={handleChange}
                      value={comment}
                    />
                  </div>
                  {isValidationError &&
                    <div className="errorMessage">{CONSTANTS.COMMENT_VALIDATION}</div>
                  }
                  <Button
                    className="commentsButton"
                    type="primary"
                    htmlType="submit"
                    onClick={onSubmitComment}
                  >
                    {CONSTANTS.SUBMIT}
                  </Button>
                </div>
              </Col>
            </Row>
          </div >
        </div >
      }
      <Modal ticketId={currentComplaintId} title={modalTitle} isVisible={isShowModal} updateStatus={updateStatus} handleCancel={() => onCancelModal()} dropDownValues={dropDownValues} actionType={actionType} />
    </div >
  );

}
